var $ = require("jquery");

var AirInformation = Backbone.View.extend({
  events: {
    "change [data-air-departure-airport]": "processAirportSelection"
  },

  processAirportSelection: function(event) {
    var airport = $(event.currentTarget).val();

    this.toggleCabinClasses(airport.toUpperCase());
  },

  toggleCabinClasses: function(airport) {
    var hasClasses = false;

    this.$("[data-air-cabin-class]")
      .find("option")
      .each(function() {
        var gateways = $(this).data("gateways") || "";

        if (gateways) {
          if (gateways.indexOf(airport) === -1) {
            $(this)
              .attr("disabled", true)
              .addClass("is-hidden");
          } else {
            $(this)
              .attr("disabled", false)
              .removeClass("is-hidden");
            hasClasses = true;
          }
        }
      });

    this.$("[data-air-cabin-class-container]")[
      hasClasses && airport ? "removeClass" : "addClass"
    ]("is-hidden");
  },

  initialize: function() {
    this.toggleCabinClasses(this.$("[data-air-departure-airport]").val());
  }
});

module.exports = AirInformation;
